/**
 * Canonical company contact and NAP fields for grihatek.com.
 *
 * Address source: founder DECIDED on GRI-326, 14 Sep 2026 — New Town / Rajarhat
 * operating address published site-wide (s.12(3)/ROC lag knowingly accepted).
 */
export const CONTACT = {
  phoneDisplay: '+91 97499 96520',
  phoneHref: 'tel:+919749996520',
  email: 'contact@grihatek.com',
  /** First line of the human-readable address block. */
  addressLine1: 'Unit 303, Tower 7, The Soul, Action Area III',
  /** Second line of the human-readable address block. */
  addressLine2: 'New Town, Rajarhat, Kolkata 700135, West Bengal, India',
  /** Single-line form used in prose (privacy policy, etc.). */
  addressFull:
    'Unit 303, Tower 7, The Soul, Action Area III, New Town, Rajarhat, Kolkata 700135, West Bengal, India',
  /** Schema.org PostalAddress fields for JSON-LD. */
  postal: {
    streetAddress: 'Unit 303, Tower 7, The Soul, Action Area III, New Town, Rajarhat',
    addressLocality: 'Kolkata',
    addressRegion: 'West Bengal',
    postalCode: '700135',
    addressCountry: 'IN',
  },
} as const;
